import React from "react";
import {
  Autocomplete,
  Box,
  Chip,
  FormControl,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { ChevronDown, CloseSmall } from "@tiny/icons";

interface TagSelectorProps {
  value: string[];
  onChange: (value: string[]) => void;
  options: string[];
  placeholder?: string;
  label?: string;
}

const TagSelector: React.FC<TagSelectorProps> = ({
  value,
  onChange,
  options,
  placeholder = "Search or type to add new tags",
  label = "Tags",
}) => {
  return (
    <FormControl fullWidth>
      <InputLabel
        sx={(theme) => ({
          backgroundColor: theme.palette.background.paper,
          px: 2,
        })}
        shrink
      >
        {label}
      </InputLabel>
      <Autocomplete
        multiple
        options={options || []}
        value={value}
        limitTags={3}
        getOptionLabel={(option) => option || ""}
        isOptionEqualToValue={(option, val) => option === val}
        filterSelectedOptions
        freeSolo
        autoSelect
        popupIcon={<ChevronDown />}
        onChange={(_, newValue) => onChange(newValue)}
        noOptionsText="Type and press Enter to add a new tag"
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            size="small"
            variant="outlined"
          />
        )}
        renderOption={(props, option) => (
          <Box component="li" {...props} key={option}>
            <Typography variant="caption">{option}</Typography>
          </Box>
        )}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Chip
              label={option}
              {...getTagProps({ index })}
              size="small"
              sx={(theme) => ({
                background: theme.palette.grey[30],
                color: theme.palette.grey[90],
                fontSize: 12,
                border: 0,
                fontWeight: 400,
              })}
              deleteIcon={<CloseSmall />}
            />
          ))
        }
      />
    </FormControl>
  );
};

export default TagSelector;
